
export const VERFIY_TWO_FA_LOGIN = 'VERFIY_TWO_FA_LOGIN';
export const GENERATE_TWO_FA_OTP = 'GENERATE_TWO_FA_OTP';
export const CHANGE_RESEND_STATUS = 'CHANGE_RESEND_STATUS';